"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = exports.removeCookie = exports.hasCookie = exports.setCookie = void 0;
function setCookie(name, value) {
    document.cookie = name + "=" + value;
}
exports.setCookie = setCookie;
function hasCookie(name) {
    return document.cookie
        .split(';')
        .some(function (item) { return item.trim().startsWith(name + "="); });
}
exports.hasCookie = hasCookie;
function removeCookie(name) {
    if (hasCookie(name)) {
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    }
}
exports.removeCookie = removeCookie;
function getCookie(name) {
    var _a;
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) {
        return (_a = parts.pop()) === null || _a === void 0 ? void 0 : _a.split(';').shift();
    }
}
exports.getCookie = getCookie;
//# sourceMappingURL=cookie.js.map